import { ProfileModel } from '../../models/ProfileModel';
import { action, computed } from 'mobx';
import { GetProfilesRequest, ProfileResource } from '@foxbun/lib-goferal-types';
import { AbstractModelStore, AbstractModelStoreOptions, BsonID } from './abstract/AbstractModelStore';
import { ObjectId } from 'bson';
import { PackStore } from './PackStore';
import { GroupStore } from './GroupStore';

export interface ProfileStoreOptions extends AbstractModelStoreOptions {
  pack_store: () => PackStore;
  group_store: () => GroupStore;
}

export class ProfileStore extends AbstractModelStore<ProfileModel, ProfileResource> {
  constructor(protected options2: ProfileStoreOptions) {
    super(options2);
  }

  @computed get users() {
    return this.data;
  }

  @action async getProfiles(req: GetProfilesRequest) {
    let profiles = await this.client.profile.getProfiles(req).call();
    return profiles.items.map((i) => {
      return this.ensureModel(i._id, i);
    });
  }

  getModel(id: BsonID): ProfileModel {
    if (this.options.session?.user?.id.toString() === id) {
      return this.options.session.user;
    }
    return super.getModel(id);
  }

  protected generateModel(id: ObjectId, data: ProfileResource | undefined): ProfileModel {
    return new ProfileModel({
      api_client: this.client,
      id: id,
      data: data,
      pack_store: this.options2.pack_store(),
      group_store: this.options2.group_store()
    });
  }
}
